import React, { Component } from 'react'
import { redirectToLoginPage } from '@driftt/web-auth'
import { AUTH_CLIENT_ID } from 'constants/ResourcesConstants'

class Logout extends Component {
  removeServiceWorkers = () => {
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      return navigator.serviceWorker
        .getRegistrations()
        .then(registrations =>
          Promise.all(
            registrations.map(registration =>
              registration
                .unregister()
                .catch(err => console.error('Unable to unsubscribe service worker', registration, err))
            )
          )
        )
    } else {
      return Promise.resolve()
    }
  }
  
  componentDidMount() {
    const params = new URLSearchParams(window.location.search)
    const timeout = params.get("timeout") === "true"
    this.removeServiceWorkers()
      .then(() => redirectToLoginPage(AUTH_CLIENT_ID, timeout))
      .catch(err => {
        console.error('Unable to unregister service worker', err)
        redirectToLoginPage(AUTH_CLIENT_ID)
      })    
  }

  render() {
    return <div />
  }
}

export default Logout



// WEBPACK FOOTER //
// ./src/scripts/components/Logout.js